import { render, staticRenderFns } from "./businessUnit.vue?vue&type=template&id=4dc0135b&scoped=true"
import script from "./businessUnit.vue?vue&type=script&lang=js"
export * from "./businessUnit.vue?vue&type=script&lang=js"
import style0 from "./businessUnit.vue?vue&type=style&index=0&id=4dc0135b&prod&lang=css"
import style1 from "./businessUnit.vue?vue&type=style&index=1&id=4dc0135b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc0135b",
  null
  
)

export default component.exports